import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useColorMode } from '@/hooks';
import { getMonth } from '@/utils/functions';

export const DateTypography = (props: { date: string | Date }) => {
    const { t } = useTranslation();
    const isDarkMode = useColorMode();
    const timeZoneOffset = new Date().getTimezoneOffset();
    const data = new Date(props.date);
    const date = new Date(data.setHours(data.getHours() - timeZoneOffset / 60));
    const day = date.getDate();
    const month = getMonth(date.getMonth()) || '';
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString();

    return (
        <Typography color={isDarkMode ? 'info.main' : 'info.light'} variant="body2">
            {`${day} ${t(month)} ${year} ${hours}:${minutes.length === 1 ? 0 + minutes : minutes}`}
        </Typography>
    );
};
